import React from 'react';
import { captureException } from '../utils/sentry';

class ComponentErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Error in component:', error, errorInfo);
        captureException(error, {
            component: 'ComponentErrorBoundary',
            componentErrorMessage: this.props.componentErrorMessage || 'Error in component.',
            componentStack: errorInfo?.componentStack,
        });
    }

    render() {
        if (this.state.hasError) {
            return <div className="text-danger">{this.props.componentErrorMessage || 'Error in component.'}</div>;
        }

        return this.props.children;
    }
}

export default ComponentErrorBoundary;
